<template>
  <div class="section">
   <div class="wrap_title">智慧报考</div>
    <!-- <div id="login-three-container"></div> -->
    <!-- 登录框 -->
    <div v-if="isShow" class="container">
      <div class="form_left">
        <div>
          <div class="logo_title">严肃性考试智能报名系统</div>
          <!-- <div>
            <img src="../../../assets/images/show.png" alt="" />
          </div> -->
        </div>
      </div>
      <div class="form">
        <!-- <h2>登录</h2> -->
        <el-form ref="loginForm" :rules="rules" :model="loginForm">
          <div class="sw">
            <div class="sw_text" :class="{ 'sw_dir': activeName === 'code' }" @click="swClick('code')">
              验证码登录
            </div>
            <div class="sw_text" :class="{ 'sw_dir': activeName === 'password' }" style="margin-left: 38px;"
              @click="swClick('password')">
              密码登录
            </div>
          </div>
          <!--  -->

          <div style="margin-top: 70px;" v-if="activeName === 'password'">
            <el-form-item prop="username" class="inputBox"
              style="border-bottom: 1px #CBD4E2 solid;padding-left: 36px;position: relative;">
              <img class="inputBox_img" src="../../../assets/images/account.png" alt="">
              <el-input v-model="loginForm.username" type="text" placeholder="请输入账号" />
            </el-form-item>
            <el-form-item prop="password" class="inputBox" style="border-bottom: 1px #CBD4E2 solid;padding-left: 36px;">
              <img class="inputBox_img" src="../../../assets/images/pass.png" alt="">
              <el-input ref="pwdInput" :type="pwdObj.pwdType" v-model="loginForm.password" @focus="focusEnd($event)"
                placeholder="请输入密码">

                <span slot="suffix" class="img-sty iconfont"
                  :class="pwdObj.pwdType === 'text' ? 'icon-yanjing' : 'icon-yanjing-bi'"
                  @click="changeye('pwdType', 'pwdInput')"></span>
              </el-input>
            </el-form-item>


          </div>

          <div style="margin-top: 70px;" v-else>
            <el-form-item prop="phone" class="inputBox" style="border-bottom: 1px #CBD4E2 solid;padding-left: 36px;position: relative;">
              <img class="inputBox_img" src="../../../assets/images/account.png" alt="">
              <el-input v-model="loginForm.phone" type="text" placeholder="请输入手机号" />
            </el-form-item>
            <el-form-item prop="smsCode" class="inputBox" style="border-bottom: 1px #CBD4E2 solid;padding-left: 36px;position: relative;margin-bottom: 0;">
              <img class="inputBox_img" src="../../../assets/images/code_icon.png" alt="">
              <el-input v-model="loginForm.smsCode" type="text" placeholder="请输入验证码" @input="input"
                :class="err.message ? 'login_error' : ''" />


            <div v-if="isCheck" class="check ck_pos" @click="getAuthCode('login')" style="color: #96A0AF;">获取验证码</div>
            <div v-else class="check-false ck_pos" style="color: #96A0AF;">重新获取({{ time }})</div>
            </el-form-item>
            <!-- <span class="tips">{{ err.message }}</span> -->

          </div>

          <!-- <el-tabs v-model="activeName" type="card" @tab-click="tabClick">
            <el-tab-pane name="code" label="验证码登录">
              <el-form-item prop="phone" class="inputBox">
                <input v-model="loginForm.phone" type="text" placeholder="手机号" />
              </el-form-item>
              <el-form-item prop="smsCode" class="inputBox">
                <input v-model="loginForm.smsCode" type="text" placeholder="验证码" @input="input"
                  :class="err.message ? 'login_error' : ''" />
              </el-form-item>
              <span class="tips">{{ err.message }}</span>

              <div v-if="isCheck" class="check" @click="getAuthCode('login')">获取验证码</div>
              <div v-else class="check-false">重新获取({{ time }})</div>
            </el-tab-pane>

            <el-tab-pane name="password" label="密码登录">
              <el-form-item prop="username" class="inputBox">
                <input v-model="loginForm.username" type="text" placeholder="用户名" />
              </el-form-item>
              <el-form-item prop="password" class="inputBox">
                <el-input ref="pwdInput" :type="pwdObj.pwdType" v-model="loginForm.password" @focus="focusEnd($event)"
                  placeholder="密码">

                  <span slot="suffix" class="img-sty iconfont"
                    :class="pwdObj.pwdType === 'text' ? 'icon-yanjing' : 'icon-yanjing-bi'"
                    @click="changeye('pwdType', 'pwdInput')"></span>
                </el-input>
              </el-form-item>
              <span class="tips">{{ err.message }}</span>

              <div v-if="isCheck" class="check"></div>

            </el-tab-pane>
          </el-tabs> -->

          <div class="inputBox" style="margin-top: 70px;">
            <el-button class="dl_btn" style="width: 100%;" type="primary" round @click="login"> 登 录 </el-button>
            <!-- <el-button class="register" round @click="register">注册</el-button> -->

          </div>
          <div style="margin-top: 50px;text-align: left;font-size: 16px;
                    font-family: Source Han Sans CN, Source Han Sans CN-400;
                    font-weight: 400;
                    color: #8a909a;
                    line-height: 22px;">
            还没账号?<span style="color: #2185FB;cursor: pointer;" @click="register">立即注册</span>
          </div>
        </el-form>
      </div>
    </div>

    <!-- 忘记密码 -->
    <div v-if="isForgetShow" class="container">
      <div>重置密码</div>
      <el-form class="content" ref="refForm" :rules="rules" :model="passwordResetForm" label-width="85px">
        <el-form-item prop="accout" label="账 号：">
          <el-input size="small" clearable v-model="passwordResetForm.accout" placeholder="输入账号"
            prefix-icon="el-icon-user">
          </el-input>
        </el-form-item>
        <el-form-item prop="checkCode" label="验证码：" class="checkCode">
          <el-input size="small" clearable v-model="passwordResetForm.checkCode" placeholder="输入验证码"></el-input>

          <el-button @click.stop="sendVerificationCode" size="mini" type="primary" style="margin-left: 10px"
            v-if="show">发送验证码</el-button>
          <el-button size="mini" type="primary" style="margin-left: 10px" v-if="!show" disabled>{{ count
            }}秒后重发</el-button>
        </el-form-item>
        <div class="sign">
          <el-button @click.stop="sign" type="primary">登 录</el-button>
        </div>
      </el-form>
    </div>

    <!-- 注册 -->
    <div v-if="isRegisterShow" class="container">
      <div class="form_left">

      </div>
      <div class="form">
        <h2 style="color: #06060694;">账号注册</h2>
        <el-form ref="registerForm" :rules="rules" :model="registerForm">
          <el-form-item prop="phone" class="inputBox" style="border-bottom: 1px #CBD4E2 solid;padding-left: 36px;position: relative;">
            <img class="inputBox_img" src="../../../assets/images/account.png" alt="">
            <el-input type="text" v-model="registerForm.phone" placeholder="请输入手机号" />
          </el-form-item>
          <el-form-item prop="authCode" class="inputBox" style="border-bottom: 1px #CBD4E2 solid;padding-left: 36px;position: relative;">
            <img class="inputBox_img" src="../../../assets/images/code_icon.png" alt="">
            <el-input type="text" v-model="authCode" placeholder="请输入验证码" :class="err.message ? 'login_error' : ''" />
            <div v-if="isCheck" class="check ck_pos" style="color: #96A0AF;" @click="getAuthCode('register')">获取验证码</div>
            <div v-else class="check-false ck_pos" style="color: #96A0AF;">重新获取({{ time }})</div>
          </el-form-item>
          <!-- <span class="tips">{{ err.message }}</span> -->

          <div class="inputBox" style="margin-top: 70px;">
            <el-button class="dl_btn" style="width: 100%;" round @click="registeredUser"> 注册 </el-button>
          </div>
          <!-- <p class="forget dl_btn" style="width: 100%;"  @click="toLogin">点击去登录</p> -->

          <div style="margin-top: 50px;text-align: left;font-size: 16px;
                    font-family: Source Han Sans CN, Source Han Sans CN-400;
                    font-weight: 400;
                    color: #8a909a;
                    line-height: 22px;">
            <span style="color: #2185FB;cursor: pointer;" @click="toLogin">点击去登录</span>
          </div>
        </el-form>
      </div>
    </div>
    <!-- <div class="login-ground"></div> -->
  </div>
</template>
<script>
// 导入整个three.js核心库
import * as THREE from 'three'
import { GUI } from 'three/examples/jsm/libs/dat.gui.module'
// 导入轨道控制器
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
// import Stats from 'three/examples/jsm/libs/stats.module.js';
import _ from 'lodash'
import {debounce} from "lodash-es";
export default {
  filters: {},
  name: 'Login',
  components: {},
  data() {
    const validatePhone = (rule, value, callback) => {
      const regExp = /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/
      if (!regExp.test(value)) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    }
    return {
      activeName: 'password',
      password: '',
      pwdObj: { pwdType: 'password' },

      isShow: true,
      isForgetShow: false,
      isRegisterShow: false,
      resetForm: {
        userName: '',
        phone: ''
      },
      loginForm: {
        phone: '',
        smsCode: '',
        channel: 'STU',
        username: '',
        password: ''
      },
      registerForm: {
        phone: '',
        smsCode: ''
      },
      authCode: '',
      isCheck: true, //显示获取验证码
      time: 60,
      passwordResetForm: {
        accout: '',
        password: '',
        checkCode: ''
      },

      rules: {
        accout: [{ required: true, message: '账号不能为空', trigger: 'blur' }],
        phone: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          {
            validator: validatePhone,
            trigger: 'change'
          }
        ],
        smsCode: [
          { required: true, message: '验证码不能为空', trigger: 'blur' },
          { max: 6, min: 6, message: '验证码为6位数字', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' },
          {
            trigger: 'blur',
            validator: (rule, value, callback) => {
              // let passwordreg =/(?=.*\d)(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,16}/;
              let passwordreg = /^[a-zA-Z0-9]+$/
              if (!passwordreg.test(value)) {
                callback(
                  // new Error("密码必须由数字、字母、特殊字符组合,请输入8-16位")
                  new Error('密码必须由数字、字母组合')
                )
              } else {
                callback()
              }
            }
          }
        ],
        checkCode: [
          { required: true, message: '验证码不能为空', trigger: 'blur' },
          { max: 4, message: '验证码为4位数字', trigger: 'blur' }
        ],
        username: [{ required: true, message: '用户名不能为空', trigger: 'blur' }]
      },
      err: {
        code: 40000,
        message: ''
      },
      show: true,
      count: '',
      timer: null,
      // threejs
      // 容器
      container: null,
      // 声明视口宽度
      width: 0,
      // 声明视口高度
      height: 0,
      // 盒模型的深度
      depth: 1400,
      // 声明场景
      scene: null,
      // 声明球组
      Sphere_Group: null,
      // 声明球体几何
      sphereGeometry: null,
      // 声明完整球
      sphere: null,
      // 声明相机
      camera: null,
      // 声明相机在z轴的位置
      zAxisNumber: 0,
      // 声明相机目标点
      cameraTarget: null,
      // 声明点材质
      materials: [],
      // 声明点的参数
      parameters: null,
      // 声明点在z轴上移动的进度
      zprogress: 0,
      // 声明同上（第二个几何点）
      zprogress_second: 0,
      // 声明粒子1
      particles_first: [],
      // 声明粒子1
      particles_second: [],
      // 声明粒子1的初始化位置
      particles_init_position: 0,
      // 声明流动的云对象1（包含路径、云实例）
      cloudParameter_first: null,
      // 声明流动的云对象2（包含路径、云实例）
      cloudParameter_second: null,
      // 声明云流动的渲染函数1
      renderCloudMove_first: null,
      // 声明云流动的渲染函数1
      renderCloudMove_second: null,
      // 声明性能监控
      // stats: null,
      // 声明渲染器
      renderer: null,
      // 声明调试工具
      gui: null
    }
  },
  computed: {},
  watch: {
    '$route.query.redirect': {
      immediate: true,
      handler(newValue, oldValue) {
        localStorage.setItem('redirectTo', newValue)
      }
    }
  },
  mounted() {
    this.gui = new GUI()
    // this.stats = new Stats();
    this.cameraTarget = new THREE.Vector3(0, 0, 0)
    // this.container = document.getElementById('login-three-container')
    // this.width = this.container.clientWidth
    // this.height = this.container.clientHeight
    // console.log('w=', this.width, "h=", this.height);

    this.initScene()
    this.initSceneBg()
    this.initCamera()
    this.initLight()
    this.initSphereModal()
    this.initSphereGroup()
    this.particles_init_position = -this.zAxisNumber - this.depth / 2
    this.zprogress = this.particles_init_position
    this.zprogress_second = this.particles_init_position * 2
    this.particles_first = this.initSceneStar(this.particles_init_position)
    this.particles_second = this.initSceneStar(this.zprogress_second)
    this.cloudParameter_first = this.initTubeRoute(
      [
        new THREE.Vector3(-this.width / 10, 0, -this.depth / 2),
        new THREE.Vector3(-this.width / 4, this.height / 8, 0),
        new THREE.Vector3(-this.width / 4, 0, this.zAxisNumber)
      ],
      400,
      200
    )
    this.cloudParameter_second = this.initTubeRoute(
      [
        new THREE.Vector3(this.width / 8, this.height / 8, -this.depth / 2),
        new THREE.Vector3(this.width / 8, this.height / 8, this.zAxisNumber)
      ],
      200,
      100
    )
    // this.initRenderer()
    // 控制器必须放在renderer函数后面
    // this.initOrbitControls()
    // this.animate()
  },
  methods: {
    swClick(val) {
      this.activeName = val
      console.log(val);
      this.$refs.loginForm.clearValidate()
      for (let key in this.loginForm) {
        this.loginForm[key] = ''
      }
      this.loginForm.channel = 'STU'
      this.$nextTick(function () {
        this.$set(this.err, 'message', '')
      })

    },
    // 点击tab切换
    tabClick() {
      this.$refs.loginForm.clearValidate()
      for (let key in this.loginForm) {
        this.loginForm[key] = ''
      }
      this.loginForm.channel = 'STU'
      this.$nextTick(function () {
        this.$set(this.err, 'message', '')
      })
    },
    //点击图标控制密码的显示和隐藏
    changeye(typeName, refName) {
      this.$set(this.pwdObj, `${typeName}`, this.pwdObj[`${typeName}`] === 'password' ? 'text' : 'password')
      this.$refs[`${refName}`].focus()
    },
    //点击查看密码图标使光标定位到最后
    focusEnd(e) {
      //input获取光标显示在最后
      const obj = e.srcElement,
        // obj.focus()
        len = obj.value.length
      //光标定位要加上 setTimeOut，不然就会重新光标定位失败
      setTimeout(() => {
        obj.selectionStart = obj.selectionEnd = len
      }, 60)
    },
    //验证码 倒计时
    sendVerificationCode() {
      let TIME_COUNT = 60
      if (!this.timer) {
        this.count = TIME_COUNT
        this.show = false
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--
          } else {
            this.show = true
            clearInterval(this.timer)
            this.timer = null
          }
        }, 1000)
        this.getCode()
      }
    },
    //验证码
    getCode() {
      axios.get('/verificationCode.json').then(res => {
        if (res.status == 200) {
          setTimeout(() => {
            this.passwordResetForm.checkCode = res.data.code
            this.show = true
            clearInterval(this.timer)
            this.timer = null
          }, 3000)
        }
      })
    },
    forget() {
      this.isForgetShow = true
      this.isShow = false
    },
    login() {
      this.$refs.loginForm.validate(valid => {
        // console.log(valid)
        if (true) {
          // delete this.loginForm.phone
          // delete this.loginForm.smsCode
          this.$store
            .dispatch('login', this.loginForm)
            .then(res => {
              if (res) {
                this.$message.success('登录成功！')
                this.$router.push('/')
                // this.$message.success('请先进入个人中心完善个人信息！')
              }
            })
            .catch(err => {
              console.log(err)
              this.err = err
              // this.$message.error(err.data || err.msg || '登录失败')
            })
        } else {
          return false
        }
      })
    },
    // 键盘输入，清空错误提示
    input() {
      this.err.message = ''
    },
    register() {
      this.isRegisterShow = true
      this.isShow = false
    },
    toLogin() {
      this.isShow = true
      this.isForgetShow = false
      this.isRegisterShow = false
    },
    /* 获取验证码 */
    getAuthCode(type) {
      if (type === 'login') {
        this.$refs.loginForm.validateField('phone', err => {
          if (!err) {
            /* 获取验证码 */
            const params = type === 'login' ? this.loginForm : this.registerForm
            this.isCheck = false
            let timer = setInterval(() => {
              if (this.time > 0) {
                this.time--
              }
              if (this.time === 0) {
                this.isCheck = true
                this.time = 60
                clearInterval(timer)
              }
            }, 1000)
            this.$store.dispatch('getAuthCode', params)
          } else {
            return false
          }
        })
      } else if (type === 'register') {
        this.$refs.registerForm.validateField('phone', err => {
          if (!err) {
            /* 获取验证码 */
            const params = type === 'login' ? this.loginForm : this.registerForm
            this.isCheck = false
            let timer = setInterval(() => {
              if (this.time > 0) {
                this.time--
              }
              if (this.time === 0) {
                this.isCheck = true
                this.time = 60
                clearInterval(timer)
              }
            }, 1000)
            this.$store.dispatch('getAuthCode', params)
          } else {
            return false
          }
        })
      }
    },
    /* 注册用户 */
    registeredUser:debounce(function (){
      if(!this.authCode){
        return this.$message.error('请输入验证码！')
      }
      this.$refs.registerForm.validate(valid => {
        if (valid) {
          const params = {
            ...this.registerForm,
            inputCode: this.authCode
          }
          this.$store
            .dispatch('registeredUser', params)
            .then(res => {
              this.$message.success('注册成功，请重新登录')
              // this.$router.replace("/main"); //注册成功实现跳转
              // this.$router.push('/')
              this.toLogin()
              this.activeName = 'code'
              this.loginForm.username = this.registerForm.phone
              this.loginForm.phone = this.registerForm.phone

              this.isCheck = true
              this.time = 60
            })
            .catch(err => {
              // this.$message.error(err)
            })
        } else {
          return false
        }
      })
    },500),
    //忘记密码提交验证后跳转登录
    forgetPassword() {
      const params = {
        userName: this.resetForm.userName,
        phone: this.resetForm.phone
      }
      this.$store
        .dispatch('resetPassword', params)
        .then(res => {
          this.$message.success('密码重置成功,请查收邮件！')
          //密码找到后在回到登录得弹框
          this.isForgetShow = false
          this.isShow = true
        })
        .catch(err => {
          // this.$message.error(err)
        })
    },
    // threejs
    // 初始化场景
    initScene() {
      this.scene = new THREE.Scene()
      // 在场景中添加雾的效果，Fog参数分别代表‘雾的颜色’、‘开始雾化的视线距离’、刚好雾化至看不见的视线距离’
      this.scene.fog = new THREE.Fog(0x000000, 0, 10000)
    },
    // 初始化背景（盒模型背景，视角在盒子里面，看到的是盒子内部）
    initSceneBg() {
      new THREE.TextureLoader().load(require('@/assets/images/sky.png'), texture => {
        const geometry = new THREE.BoxGeometry(this.width, this.height, this.depth) // 创建一个球形几何体 SphereGeometry
        const material = new THREE.MeshBasicMaterial({ map: texture, side: THREE.BackSide }) // 创建基础为网格基础材料
        const mesh = new THREE.Mesh(geometry, material)
        this.scene.add(mesh)
      })
    },
    // 初始化相机
    initCamera() {
      /**
       * 方式1：固定视野的距离，求满足完整的视野画面需要多大的视域角度
       * tan正切值（直角边除以临边）
       * const mathTan_value = width / 2 / depth
       * 视域角度
       * const fov_angle = (Math.atan(mathTan_value) * 180) / Math.PI
       * 创建透视相机
       * new THREE.PerspectiveCamera(fov_angle, width / height, 1, depth)
       * 场景是一个矩形容器（坐标(0, 0, 0)是矩形容器的中心），相机能看到的距离是depth，
       * camera.position.set(0, 0, depth / 2)
       */

      /**
       * 使用透视相机
       * 参数值分别是：
       * fov（field of view） — 摄像机视锥体垂直视野角度
       * aspect — 摄像机视锥体长宽比
       * near — 摄像机视锥体近端面
       * far — 摄像机视锥体远端面
       * 这里需要注意：透视相机是鱼眼效果，如果视域越大，边缘变形越大。
       * 为了避免边缘变形，可以将fov角度设置小一些，距离拉远一些
       */

      /**
       * 方式2:固定视域角度，求需要多少距离才能满足完整的视野画面
       * 15度等于(Math.PI / 12)
       */
      const fov = 15
      const distance = this.width / 2 / Math.tan(Math.PI / 12)
      this.zAxisNumber = Math.floor(distance - this.depth / 2)
      this.camera = new THREE.PerspectiveCamera(fov, this.width / this.height, 1, 30000)
      /**
       * 这里给z轴的距离加了100，原因是做调整，使得视域更完整
       * 这么做并不代表前面计算错误了，根据前面的计算值并不能很完整的看到
       * 至于原因，我想大概就类似于0.1+0.2不等于0.3吧
       * 所以我自作主张地加了100的值做调整（但是不建议，因为当屏幕足够宽时候会看到边缘）
       */
      // camera.position.set(0, 0, zAxisNumber + 100)
      this.camera.position.set(0, 0, this.zAxisNumber)
      this.camera.lookAt(this.cameraTarget)
      // const helper = new THREE.CameraHelper(camera)
      // helper.update()
      // scene.add(helper)
    },
    //光源
    initLight() {
      const ambientLight = new THREE.AmbientLight(0xffffff, 1)
      // 右下角点光源
      const light_rightBottom = new THREE.PointLight(0x0655fd, 5, 0)
      light_rightBottom.position.set(0, 100, -200)
      this.scene.add(light_rightBottom)
      this.scene.add(ambientLight)
    },
    // 初始化球体模型
    initSphereModal() {
      //材质
      let material = new THREE.MeshPhongMaterial()
      material.map = new THREE.TextureLoader().load(require('@/assets/images/earth_bg.png'))
      material.blendDstAlpha = 1
      //几何体
      this.sphereGeometry = new THREE.SphereGeometry(50, 64, 32)
      //模型
      this.sphere = new THREE.Mesh(this.sphereGeometry, material)
      // this.sphere.rotation.y = Math.PI / 3;
    },
    // 渲染星球的自转
    renderSphereRotate() {
      if (this.sphere) {
        this.Sphere_Group.rotateY(0.002)
      }
    },

    // 初始化组 --- 球体
    initSphereGroup() {
      this.Sphere_Group = new THREE.Group()
      this.Sphere_Group.add(this.sphere)
      this.Sphere_Group.position.x = -400
      this.Sphere_Group.position.y = 200
      this.Sphere_Group.position.z = -200
      this.scene.add(this.Sphere_Group)
    },
    // 初始化流动路径
    initTubeRoute(route, geometryWidth, geometryHeigh) {
      const curve = new THREE.CatmullRomCurve3(route, false)
      const tubeGeometry = new THREE.TubeGeometry(curve, 100, 2, 50, false)
      const tubeMaterial = new THREE.MeshBasicMaterial({
        // color: '0x4488ff',
        opacity: 0,
        transparent: true
      })
      const tube = new THREE.Mesh(tubeGeometry, tubeMaterial)
      this.scene.add(tube)

      const clondGeometry = new THREE.PlaneGeometry(geometryWidth, geometryHeigh)
      const textureLoader = new THREE.TextureLoader()
      const cloudTexture = textureLoader.load(require('@/assets/images/cloud.png'))
      const clondMaterial = new THREE.MeshBasicMaterial({
        map: cloudTexture,
        blending: THREE.AdditiveBlending,
        depthTest: false,
        transparent: true
      })
      const cloud = new THREE.Mesh(clondGeometry, clondMaterial)
      this.scene.add(cloud)
      return {
        cloud,
        curve
      }
    },
    // 初始化场景星星效果
    initSceneStar(initZposition) {
      const geometry = new THREE.BufferGeometry()
      const vertices = []
      const pointsGeometry = []
      const textureLoader = new THREE.TextureLoader()
      const sprite1 = textureLoader.load(require('@/assets/images/starflake1.png'))
      const sprite2 = textureLoader.load(require('@/assets/images/starflake2.png'))
      this.parameters = [
        [[0.6, 100, 0.75], sprite1, 50],
        [[0, 0, 1], sprite2, 20]
      ]
      // 初始化500个节点
      for (let i = 0; i < 500; i++) {
        /**
         * const x: number = Math.random() * 2 * width - width
         * 等价
         * THREE.MathUtils.randFloatSpread(width)
         */
        const x = THREE.MathUtils.randFloatSpread(this.width)
        const y = _.random(0, this.height / 2)
        const z = _.random(-this.depth / 2, this.zAxisNumber)
        vertices.push(x, y, z)
      }

      geometry.setAttribute('position', new THREE.Float32BufferAttribute(vertices, 3))

      // 创建2种不同的材质的节点（500 * 2）
      for (let i = 0; i < this.parameters.length; i++) {
        const color = this.parameters[i][0]
        const sprite = this.parameters[i][1]
        const size = this.parameters[i][2]

        this.materials[i] = new THREE.PointsMaterial({
          size,
          map: sprite,
          blending: THREE.AdditiveBlending,
          depthTest: true,
          transparent: true
        })
        this.materials[i].color.setHSL(color[0], color[1], color[2])
        const particles = new THREE.Points(geometry, this.materials[i])
        particles.rotation.x = Math.random() * 0.2 - 0.15
        particles.rotation.z = Math.random() * 0.2 - 0.15
        particles.rotation.y = Math.random() * 0.2 - 0.15
        particles.position.setZ(initZposition)
        pointsGeometry.push(particles)
        this.scene.add(particles)
      }
      return pointsGeometry
    },
    //渲染器
    initRenderer() {
      // 开启抗锯齿
      // 在 css 中设置背景色透明显示渐变色
      this.renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true })
      // 定义渲染器的尺寸；在这里它会填满整个屏幕
      this.renderer.setSize(this.width, this.height)
      this.renderer.shadowMap.enabled = true
      this.renderer.shadowMap.type = THREE.PCFSoftShadowMap
      this.container.appendChild(this.renderer.domElement)
      // this.container.appendChild(this.stats.dom)
      this.renderCloudMove_first = this.initCloudMove(this.cloudParameter_first, 0.0002)
      this.renderCloudMove_second = this.initCloudMove(this.cloudParameter_second, 0.0008, 0.001)
    },
    // 初始化轨道控制器
    initOrbitControls() {
      const controls = new OrbitControls(this.camera, this.renderer.domElement)
      // enabled设置为true是可以使用鼠标控制视角
      controls.enabled = false
      controls.update()
    },
    //动画刷新
    animate() {
      requestAnimationFrame(this.animate)
      this.renderSphereRotate()
      this.renderStarMove()
      this.renderCloudMove_first()
      this.renderCloudMove_second()
      this.renderer.render(this.scene, this.camera)
    },
    // 渲染星星的运动
    renderStarMove() {
      const time = Date.now() * 0.00005
      this.zprogress += 1
      this.zprogress_second += 1

      if (this.zprogress >= this.zAxisNumber + this.depth / 2) {
        this.zprogress = this.particles_init_position
      } else {
        this.particles_first.forEach(item => {
          item.position.setZ(this.zprogress)
        })
      }
      if (this.zprogress_second >= this.zAxisNumber + this.depth / 2) {
        this.zprogress_second = this.particles_init_position
      } else {
        this.particles_second.forEach(item => {
          item.position.setZ(this.zprogress_second)
        })
      }

      for (let i = 0; i < this.materials.length; i++) {
        const color = this.parameters[i][0]

        const h = ((360 * (color[0] + time)) % 360) / 360
        this.materials[i].color.setHSL(color[0], color[1], parseFloat(h.toFixed(2)))
      }
    },
    // 初始化云的运动函数
    initCloudMove(cloudParameter, speed, scaleSpeed = 0.0006, maxScale = 1, startScale = 0) {
      let cloudProgress = 0
      return () => {
        if (startScale < maxScale) {
          startScale += scaleSpeed
          cloudParameter.cloud.scale.setScalar(startScale)
        }
        if (cloudProgress > 1) {
          cloudProgress = 0
          startScale = 0
        } else {
          cloudProgress += speed
          if (cloudParameter.curve) {
            const point = cloudParameter.curve.getPoint(cloudProgress)
            if (point && point.x) {
              cloudParameter.cloud.position.set(point.x, point.y, point.z)
            }
          }
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@media screen and (min-width: 320px) and (max-width: 768px) {
  @import '../styles/login.mobile';
}

@media screen and (min-width: 769px) {
  @import '../styles/login.pc';
}
</style>
